export const FLAGS_UPDATE = 'FLAGS_UPDATE';

/**
 *
 * @param {{ local?: boolean, remote?: boolean }} payload
 */
export const updateFlags = (payload) => (dispatch) => {
  dispatch({
    type: FLAGS_UPDATE,
    payload,
  });
};
